/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for comparisonOperatorType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="comparisonOperatorType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="equalTo"/&gt; &lt;enumeration value="greaterThan"/&gt; &lt;enumeration value="lessThan"/&gt; &lt;enumeration value="greaterThanOrEqualTo"/&gt; &lt;enumeration value="lessThanOrEqualTo"/&gt; &lt;enumeration value="notEqualTo"/&gt; &lt;enumeration value="equalToOrBothNull"/&gt; &lt;enumeration value="notEqualToOrOneNull"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class ComparisonOperatorType extends Enum{

	enumValue = null;

	/**
	 * Equal to.
	 */
	static  EQUAL_TO = ComparisonOperatorType.newLiteral("equalTo");

	/**
	 * Greater than.
	 */
	static  GREATER_THAN = ComparisonOperatorType.newLiteral("greaterThan");

	/**
	 * Less than.
	 */
	static  LESS_THAN = ComparisonOperatorType.newLiteral("lessThan");

	/**
	 * Greater than or equal to.
	 */
	static  GREATER_THAN_OR_EQUAL_TO = ComparisonOperatorType.newLiteral("greaterThanOrEqualTo");

	/**
	 * Less than or equal to.
	 */
	static  LESS_THAN_OR_EQUAL_TO = ComparisonOperatorType.newLiteral("lessThanOrEqualTo");

	/**
	 * Not equal to.
	 */
	static  NOT_EQUAL_TO = ComparisonOperatorType.newLiteral("notEqualTo");

	/**
	 * Equal to or both are null values. equivalent to IS NOT DISTINCT FROM in SQL standard.
	 */
	static  EQUAL_TO_OR_BOTH_NULL = ComparisonOperatorType.newLiteral("equalToOrBothNull");

	/**
	 * Not equal to or only one null of the two values. equivalent to IS DISTINCT FROM in SQL standard.
	 */
	static  NOT_EQUAL_TO_OR_ONE_NULL = ComparisonOperatorType.newLiteral("notEqualToOrOneNull");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < ComparisonOperatorType.values().length); ++i) {
			if (ComparisonOperatorType.values()[i].enumValue == v) {
				return ComparisonOperatorType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("ComparisonOperatorType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/ComparisonOperatorType.js